import Vue from 'vue';
import App from './App.vue';
import Vant from 'vant';
import 'vant/lib/index.css';
import router from './router';
import http from './http';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import common from './common/function'
import 'swiper/swiper-bundle.css'
import store from './store'
import VueI18n from 'vue-i18n';
import { Icon } from 'vant';
import 'video.js/dist/video-js.css'
import VueCookies from 'vue-cookies'
Vue.prototype.$http = http
Vue.prototype.common = common
Vue.config.productionTip = false
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
Vue.use(Vant);
Vue.use(Icon);
Vue.use(VueI18n);
Vue.use(VueCookies)
const savedLang = localStorage.getItem("lang") || "es";
const i18n = new VueI18n({
  globalInjection: true, 
  locale: ['ja', 'en', 'es'].indexOf(savedLang) !== -1 ? savedLang : 'es',
  fallbackLocale: 'es',
  messages: {
    'ja': require('./assets/languages/ja.json'),
    'en': require('./assets/languages/en.json'),
    'es': require('./assets/languages/es.json')
  }
});
if (!localStorage.getItem("lang")) {
  localStorage.setItem("lang", i18n.locale);
}
new Vue({
  store,
  router,
  i18n,
  render: h => h(App),
}).$mount('#app')
